import { Link } from "react-router-dom";
import "./StatCard.scss";

// tile de KPI para o Dashboard: label, valor, e opcionalmente uma nota
// (ex. "últimos 30 dias") e um link (ex. card de alerta -> /unanswered)
export default function StatCard({
  label,
  value,
  hint,
  icon,
  variant = "default", // default | warning | danger
  to,
  loading = false,
}) {
  const content = (
    <>
      <div className="stat-card-top">
        <span className="stat-card-label">{label}</span>
        {icon && <span className="stat-card-icon">{icon}</span>}
      </div>
      <div className="stat-card-value">{loading ? "—" : value}</div>
      {hint && <div className="stat-card-hint">{hint}</div>}
    </>
  );

  const className = `stat-card ${variant}`;

  if (to) {
    return (
      <Link to={to} className={`${className} linkable`}>
        {content}
      </Link>
    );
  }

  return <div className={className}>{content}</div>;
}
